<template>


    <div style="padding:.5em 1em">
      <!-- 1. 匿名网站声明 -->
      <div class="doc-item">
        <div class="doc-title">一、用户协议总则</div>
        <div class="doc-content">
          <p>1、本协议双方为<strong >李军 （以下简称"运营方"）</strong>和<strong >旅途向导者（包括网站等产品提供的服务，以下简称"产品和服务"）</strong>的<strong >注册用户（以下简称"用户"）</strong></p>
          <p>2、用户在首次使用前请仔细阅读本协议的条款。</p>
          <p>3、用户在首次访问本站时点击“<strong >同意并继续</strong>”按钮，即表示用户已充分知悉和完全接受本协议项下全部条款，进而与运营方达成本协议。</p>
          <p>4、运营方有权不时对本协议项下相关规则作出修改或补充，并于网站公布。用户若继续使用即视为您接受修订后的本协议条款。</p>
        </div>
      </div>
      <!-- 1. 匿名网站声明 -->
      <div class="doc-item">
        <div class="doc-title">二、用户服务使用说明</div>
        <div class="doc-content">
          <p>1、用户在注册时应按照注册提示填写准确的 手机号码 等相关个人资料，符合完整、准确、真实的要求。</p>
          <p>2、用户一旦注册成功，便成为运营方合法的注册用户。用户应对其账号安全负全部责任，并应对其用户名下所进行的所有行为和事件承担相应的法律责任。</p>
          <p>3、用户同意接受运营方通过或其他方式向用户发送有关商业信息。</p>
          <p>4、运营方不对用户所发布信息的删除或储存失败负责。</p>
          <p>5、运营方有判定用户的行为是否符合本网站服务条款要求的权利，如果用户违背了服务条款的规定，本网站有权对其用户所提供的网络服务进行中断或停止使用。</p>
          <p>6、运营方提供账号删除服务，如果用户需要删除账号，可以通过本协议中的联系方式与我们联系。 </p>
          <p>7、用户不得以任何非法目的或其它方式对运营方的个人用户账号进行转让、转借、倒卖、账号共享等行为（用户账号仅限由其本人使用）。 </p>
        </div>
      </div>

      <!-- 2. 运营方信息 -->
      <div class="doc-item">
        <div class="doc-title">三、协议内容的变更和修订</div>
        <div class="doc-content">
          <p>1、运营方有权在必要时修改服务条款，修改后的协议可以在运营方上查看。</p>
          <p>2、用户如果不同意运营方所改动的内容，可自行停止使用本站网络服务。</p>
          <p>3、如果用户继续享用本站网络服务，则视为同意接受本网站服务条款的变动。</p>
          <p>4、运营方可随时根据实际情况中断或终止一项或多项网络服务而无需对任何用户或第三方承担任何责任，如用户对一项或多项网络服务的中断或终止有异议，可以行使如下权利：</p>
          <ul>
            <li>（1）自行停止使用运营方的网络服务。</li>
            <li>（2）通知运营方停止对该用户的服务。 结束用户服务后，用户使用网络服务的权利立即终止，从终止时起，用户没有权利再进行处理任何未完成的信息或服务，运营方也没有义务为其传送任何未处理的信息或未完成的服务给用户或任何第三方。</li>
          </ul>
        </div>
      </div>

      <!-- 3. 使用注意事项 -->
      <div class="doc-item">
        <div class="doc-title">四、用户隐私保护</div>
        <div class="doc-content">
          <p>运营方将严格履行用户个人隐私保密义务，承诺不公开、编辑或透露用户个人信息，但以下特殊情况除外：</p>
          <ul>
            <li>1、经注册用户事先许可授权；</li>
            <li>2、遵守国家法律法规或配合相关政府部门的要求；</li>
            <li>3、遵从运营方合法服务程序；</li>
            <li>4、为维护社会公众利益以及运营方的合法权益所必须。</li>
          </ul>
        </div>
      </div>

      <!-- 4. 功能开关设置 -->
      <div class="doc-item">
        <div class="doc-title">五、注册用户的权利与义务</div>
        <div class="doc-content">
          <p>1、注册用户在使用运营方产品和服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，否则用户将自行承担由此产生的一切法律责任。</p>
          <p>2、用户在账号使用过程中不得上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：</p>
          <ul>
            <li>（1）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
            <li>（2）损害国家荣誉和利益的；</li>
            <li>（3）煽动民族仇恨、民族歧视、破坏民族团结的；</li>
            <li>（4）破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>（5）散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
            <li>（7）侮辱或者诽谤他人，侵害他人合法权利的；</li>
            <li>（8）含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容。</li>
          </ul>
          <p>3、不得为任何非法目的而使用网络服务系统。</p>
          <p>4、不得利用运营方产品和服务故意制作、传播计算机病毒等破坏性程序，或其他从事任何危害计算机信息网络安全的行为。</p>
          <p>5、若用户行为违反上述约定，运营方有权作出独立判断并立即取消用户的服务账号，用户应对自己网上的行为承担一切法律责任，运营方的系统记录有可能作为用户违反法律的证据提交给相关主管部门。</p>
          <p>6、用户应同意保障和维护运营方全体成员及其他用户的利益，如因违反本协议或违反有关的法律法规而给运营方或任何第三者造成损失，用户应承担因此产生的法律责任。</p>
        </div>
      </div>

      <!-- 5. 技术栈信息 -->
      <div class="doc-item">
        <div class="doc-title">六、运营方网络服务内容的所有权</div>
        <div class="doc-content">
          <p>1、运营方定义的网络服务内容包括但不限于：资料、声音、图片、视频、在线办公、线上服务等。该等内容均受《著作权法》、《商标法》、《专利法》、《计算机软件保护条例》及其他相关法律法规的保护。</p>
          <p>2、未经运营方或其他有权第三方的事先许可授权，用户不得对包括但不限于：图片、视频、网站布局、网站源码等在内的任何内容进行转载、翻录、复制、发行、破解、信息网络传播或其他违反知识产权相关法律、法规的行为，否则所导致的一切民事、行政或刑事责任，由用户自行承担。</p>
          <!--              <ul>
                          <li>前端框架：Vue 2.x</li>
                          <li>UI组件库：Vant 2.x</li>
                          <li>状态管理：Vuex</li>
                          <li>路由管理：Vue Router</li>
                          <li>数据存储：LocalStorage、Redis等</li>
                        </ul>
                        <a href="#" class="tech-link" onclick="router.push('/link-share')">
                          查看详细技术实现说明
                          <i>→</i>
                        </a>-->
        </div>
      </div>

      <!-- 6. 免责条款 -->
      <div class="doc-item">
        <div class="doc-title">七、免责声明</div>
        <div class="doc-content">
          <p>1、用户同意承担使用运营方产品和服务所存在的一切风险以及因使用网络服务而产生的一切后果，运营方对用户不承担任何责任。</p>
          <p>2、运营方不担保服务一定能满足用户的要求，也不担保服务不会中断，亦对服务的及时性，安全性及可能发生的技术错误均不作任何担保。</p>
          <p>3、任何由于黑客攻击、计算机病毒侵入或发作、政府管制、硬件故障、不可抗力等非运营方故意或严重过失而造成的用户个人资料泄露、丢失、被盗用、被篡改或服务暂定或终止的，对用户可能造成的风险或损失，运营方不承担法律责任。</p>
          <ul>
            <li>本网站按"现状"提供，不提供任何明示或暗示的保证</li>
            <li>运营方不对因使用本网站而产生的任何直接或间接损失负责</li>
            <li>运营方保留随时修改、暂停或终止服务的权利，恕不另行通知</li>
            <li>用户应对其在本网站上的行为承担全部责任</li>
            <li>运营方有权删除任何不当内容，无需提前通知</li>
          </ul>
        </div>
      </div>

      <!-- 7. 其他事项 -->
      <div class="doc-item">
        <div class="doc-title">八、其他约定</div>
        <div class="doc-content">
          <p>1、用户同意因本平台服务产生的任何争议均适用中华人民共和国法律，相关争议任何一方可向运营方住所地人民法院提起诉讼解决。</p>
          <p>2、本协议中的标题仅为方便而设，不影响对于条款本身的解释。本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，其余条款仍应具有约束力。</p>
        </div>
      </div>
      <div class="doc-item">
        <div class="doc-title">九、联系我们</div>
        <div class="doc-content">
          <p>如果您对本协议或本服务有任何疑问、意见或建议，可通过以下方式与我们联系：</p>
          <ul>
            <li>（1）拨打开发人员电话（仅限已知用户）</li>
            <li>（2）发送电子邮件至：2236191873@qq.com</li>
            <li>（3）其他联系方式，详见&thinsp;<van-tag  type="primary" @click="$router.push('/about')">关于本站&nbsp;<i class="iconfont icon-to-link"></i></van-tag>&thinsp;页面</li>
          </ul>
          <p>2、本协议中的标题仅为方便而设，不影响对于条款本身的解释。本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，其余条款仍应具有约束力。</p>
        </div>
      </div>
      <div class="doc-item">
        <div class="doc-title">十、本站使用的服务以及部分功能开关</div>
        <div class="doc-content">
          <p>1、为优化用户使用体验，本站使用了一些基于第三方的功能库、API，详细使用的第三方库列表可到&thinsp;<van-tag  type="primary" @click="$router.push('/link-share')">技术分享&nbsp;<i class="iconfont icon-to-link"></i></van-tag>&thinsp;页面查看</p>
          <p>2、一些服务为可选功能，即使您开启了该功能也并不代表您可以直接使用，这些服务通常需要一些权限，具体详询本站开发人员。您可以在此直接设置：</p>
          <div style="display: flex;flex-direction: column;justify-content: flex-start;align-items: flex-start;gap: .5em">
            <evan-cell title="使用Redis非关系型数据库">
              <template #titleAppend>
                <van-switch size="18" v-model="$store.state.useRedis" @click="changeItem('useRedis')"></van-switch>
              </template>
              <template #bottom><div style="font-size: .8em;color: var(--footer-color)">启用后，部分数据将使用Redis进行缓存，提升网站性能</div></template>
            </evan-cell>
            <evan-cell title="AI分析功能">
              <template #titleAppend>
                <van-switch size="18" v-model="$store.state.useAI" @click="changeItem('useAI')"></van-switch>
              </template>
              <template #bottom><div style="font-size: .8em;color: var(--footer-color)">启用后，特定功能将使用AI进行分析处理（相关功能会处显示具体的AI标识）</div></template>
            </evan-cell>
            <evan-cell title="其他基于服务器的第三方服务">
              <template #titleAppend>
                <van-switch size="18" v-model="$store.state.useThirdService" @click="changeItem('useThirdService')"></van-switch>
              </template>
              <template #bottom><div style="font-size: .8em;color: var(--footer-color)">启用后，网站可能会使用第三方服务来增强功能，若不开启本功能，则无法使用包括Redis、AI在内的所有后端服务</div></template>
            </evan-cell>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import {changeProperty} from "@/utils/global-config";
import EvanCell from "@/components/EvanCell.vue";

export default {
  name: "UserAgreement",
  components: {EvanCell},
  data() {
    return{

    }
  },
  methods:{
    changeItem(key, value) {
      console.log(key, this.$store.state[key], this[key]);
      changeProperty(this, undefined, key, !this.$store.state[key]);
    },

  }
}
</script>

<style scoped>

.doc-item{
  margin-bottom: 1em;
}
.doc-title {
  line-height: 1.5;
  font-size: 1.2em;
  color: var(--active-color);
  font-weight: 900;
}
.doc-content *{
  line-height: 1.5;
}
.doc-content>p>strong{
  color: var(--positive-color);
}
.doc-content {
  font-size: .9em;
  color: var(--text-color);
  & li{
    display: flex;;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
